import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import WhyChoose1Icon from '../../svgs/whychoose1.svg';
import WhyChoose2Icon from '../../svgs/whychoose2.svg';
import WhyChoose3Icon from '../../svgs/whychoose3.svg';

interface WhyChooseProps {
    header: string;
    left: string;
    center: string;
    right: string;
}

const WhyChoose: React.FC<WhyChooseProps> = ({ header, left, center, right }) => {
    return (
        <div className="text-center mx-5 px-5 py-5 font-weight-normal">
            <div className="page-section-inner container-fluid">
                <h2 className="e2g-header_title text-primary mb-4 font-weight-light">{header}</h2>
                <Row>
                    <Col md={4}>
                        <WhyChoose1Icon aria-label="in-depth-courses" className="e2g-whychoose_icon" />
                        <div className="font-weight-light e2g-description text-secondary text-center">{left}</div>
                    </Col>
                    <Col md={4}>
                        <WhyChoose2Icon aria-label="local-schools-employers-know" className="e2g-whychoose_icon" />
                        <div className="font-weight-light e2g-description text-secondary text-center">{center}</div>
                    </Col>
                    <Col md={4}>
                        <WhyChoose3Icon
                            aria-label="financial-assistance-career-training-courses"
                            className="e2g-whychoose_icon"
                        />
                        <div className="font-weight-light e2g-description text-secondary text-center">{right}</div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export { WhyChoose, WhyChooseProps };
